<template>
    <div class="content" ref="content">
        <el-page-header @back="goBack"></el-page-header>
        <div class="box-card" shadow="never">
            <el-row :gutter="20">
                <el-col :span="4" class="left">
                    <el-dropdown @command="userCommand" trigger="click">
                        <span class="el-dropdown-link">
                            <div>
                                <span>{{userClassifyName}}</span>
                                <span>({{userList.length}})</span>
                            </div>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="item" v-for="item in userClassify" :key="item.value">{{item.label}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="user-list-box">
                        <p 
                            :class="{'user-list-active': item.underwayId == userId}"
                            class="user-list" 
                            v-for="item in userList" 
                            :key="item.underwayId"
                            @click="userClick(item.underwayId)"
                        >
                            <i class="el-icon-user"></i>{{item.userName}}
                        </p>
                    </div>
                </el-col>
                <el-col :span="16" class="center">
                    <p class="paper-header">答题详情</p>
                    <div class="paper-body" v-if="userList.length > 0" v-loading="loading">
                        <AnsweredPreview v-if="examPaperItem.length > 0"  :data="examPaperItem" :isPreview="isPreview"></AnsweredPreview>
                    </div>
                    
                </el-col>
                <el-col :span="4" class="right">
                    <template v-if="userList.length > 0">
                        <p class="right-header">当前得分<span class="num">{{sumScoreValue}}</span></p>
                        <el-card class="answerSheet" shadow="never" :body-style="{ padding: '0px' }">
                            <div slot="header" class="header">
                                <span class="title">答题卡</span>
                                <div class="sign">
                                    <span class="sign1">正确 {{correctNum}}</span>
                                    <span class="sign2">错误 {{errorNum}}</span>
                                </div>
                            </div>
                            <div class="body">
                                <div class="item_list" 
                                    :class="{'item_list1': item.isCorrect == 1, 'item_list2': item.isCorrect == 2}" 
                                    v-for="(item, index) in examPaperItem" 
                                    @click="goAnchor(`name${index}`)" 
                                    :key="index"
                                    >
                                    {{item.quesIndex || item.quesIndex == 0 ? item.quesIndex + 1 : ''}}
                                </div>
                                
                            </div>
                            <div class="btn-box">
                                <el-button-group class="page-btn">
                                    <el-button size="mini" :disabled="page == 1" @click="lastPage" type="primary">上一页</el-button>
                                    <el-button  size="mini" :disabled="page == examPaper.length" @click="nextPage" type="primary">下一页</el-button>
                                    <el-button  size="mini" type="primary"  @click="submit">保存</el-button>
                                </el-button-group>
                            </div>
                            <div class="clearfix footer-box itemC">
                                <el-button-group class="page-btn">
                                    <el-button  size="mini" type="primary" :disabled="userList[0].underwayId == userId" @click="lastAnswerSheet">上一份答卷</el-button>
                                    <el-button  size="mini" type="primary" :disabled="userList[userList.length - 1].underwayId == userId" @click="nextAnswerSheet">下一份答卷</el-button>
                                </el-button-group>
                            </div>
                        </el-card>
                    </template>
                </el-col>
            </el-row>
            <div class="page-box">
                
            </div>
        </div>
    </div>
</template>

<script>
import AnsweredPreview from './components/answeredPreview.vue'
import qs from 'qs'
export default {
    name: 'ExamScore',
    components:{
        AnsweredPreview
    },
    data() {
        return{
            loading: false,
            radioRule: 1,
            input: '',
            id: '',
            questions: [],
            userId: '',
            examPaper: [],
            examPaperItem: [],
            list: [],
            page: 1,
            sumScoreValue: 0,
            scoreState: 2,
            userClassify: [
                {
                    value: 2,
                    label: '全部名单'
                },
                {
                    value: 0,
                    label: '已评分名单'
                },
                {
                    value: 1,
                    label: '待评分名单'
                }
            ],
            userClassifyName: '全部名单',
            userList: [],
            isPreview: 1, // 是否为预览 1 否
            correctNum: 0,
            errorNum: 0
        }
    },
    watch: {
        'examPaperItem':{
            handler(newV, oldV) {
                let Score = 0
                this.correctNum = this.errorNum = 0
                this.examPaper.forEach(info => {
                    info.forEach(item => {
                        Score = Score + parseInt(item.userGetScoreValue)
                        if(item.isCorrect == 1) {
                            this.correctNum++
                        } else if (item.isCorrect == 2) {
                            this.errorNum++
                        }
                    })
                })
                this.sumScoreValue = Score
            },
            deep: true
        }
    },
    created() {
        if(sessionStorage.getItem("examId")){
            this.id = sessionStorage.getItem("examId")
        } else {
            this.id = this.$route.params.id
        }
        this.getUser()
    },
    mounted() {
    },
    methods:{
        goBack() {
            this.$router.go(-1)
        },
        lastPage() {
            if (this.page > 1) {
                this.page --
                this.examPaperItem = this.examPaper[this.page - 1]
                this.examPaperItem = this.getExamPaperItem(this.examPaperItem)
            }
        },
        getExamPaperItem(arr) {
            arr.forEach((info) => {
                this.$set(info, 'correctAnswer', '')
                this.$set(info, 'isCorrect', info.isTrue)
                if (info.questionsTypeId == 100 
                    || info.questionsTypeId == 102){
                    info.optionList.forEach((item) => {
                        if (item.oid == info.answer) {
                            info.correctAnswer = item.labelName
                        }
                        if (info.userResult.indexOf(item.oid) !== -1 && info.userResult.indexOf(':') !== -1){
                            item.inputValue = info.userResult.split(':')[1]
                        }
                    })
                } else if(info.questionsTypeId == 101 ){
                    let arr = [],inputValueArr = []
                    info.optionList.forEach((item) => {
                        if (info.answer.indexOf(item.oid) != -1) {
                            arr.push(item.labelName)
                        }
                        inputValueArr = info.userResult.split(',')
                        if (inputValueArr.length > 0) {
                            inputValueArr.forEach((val) => {
                                if (val.indexOf(item.oid) !== -1 && val.indexOf(':') !== -1){
                                    item.inputValue = val.split(':')[1]
                                }
                            })
                        }
                    })
                    info.correctAnswer = arr.join(',')
                }else if (info.questionsTypeId == 204 
                    || info.questionsTypeId == 206){
                    info.correctAnswer = info.answer
                } else if(info.questionsTypeId == 207 || info.questionsTypeId == 208){
                    let arr = [], userResult = []
                    if (info.userResult) {
                        userResult = JSON.parse(info.userResult)
                    }
                    if (info.optionList && info.optionList.length > 0) {
                        info.optionList.forEach((val) => {
                            this.$set(val, 'userResult', '')
                            arr.push(val.answer)
                            if(userResult && userResult.length > 0) {
                                userResult.forEach(j => {
                                    if (val.oid == j.oid) {
                                        val.userResult = j.value
                                    }
                                })
                            }
                        })
                        info.correctAnswer = arr.join(',')
                    }
                }
            })
            return arr
        },
        nextPage() {
            if (this.page < this.examPaper.length) {
                this.page++
                this.examPaperItem = this.examPaper[this.page - 1]
                this.examPaperItem = this.getExamPaperItem(this.examPaperItem)
            }
        },
        userClick(id) {
            this.userId = id
            this.getData()
        },
        userCommand(e) {
            this.scoreState = e.value
            this.userClassifyName = e.label
            this.getUser()
        },
        lastAnswerSheet(){
            for(let i in this.userList){
                if (this.userList[i].underwayId == this.userId && i != 0){
                    console.log(this.userList[parseInt(i) - 1])
                    this.userId = this.userList[parseInt(i) - 1].underwayId
                    this.getData()
                    return 
                }
            }
        },
        nextAnswerSheet(){
            for(let i in this.userList){
                if (this.userList[i].underwayId == this.userId && i != this.userList.length - 1){
                    console.log(parseInt(i) + 1)
                    console.log(this.userList[parseInt(i) + 1])
                    this.userId = this.userList[parseInt(i) + 1].underwayId
                    this.getData()
                    return 
                }
            }
        },
        getUser() {
            let that = this
            let data = qs.stringify({
                "surveyId": this.id,
            })
            
            if (this.scoreState != 2) {
                data = `${data}&scoreState=${parseInt(this.scoreState)}`
            }
            let params = {
                that: this,
                url: `${this.$config.service.examUserList}?${data}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        that.userList = res.resultBody
                        // console.log(that.userList.length)
                        if (that.$route.params.userId){
                            that.userId = that.$route.params.userId
                            that.getData()
                        } else if (that.userList.length > 0) {
                            // console.log('123123')
                            that.userId = that.userList[0].underwayId
                            that.getData()
                        }
                        console.log(res.resultBody)
                    }
                },
            };
            this.$util.request(params);
        },
        submit() {
            let that = this
            let arr = []
            this.examPaper.forEach((val) => {
                val.forEach((info, index) => {
                    arr.push({
                        qid: info.qid,
                        userGetScoreValue: parseInt(info.userGetScoreValue),
                        isTrue: info.isCorrect,
                        score: info.score
                    })
                })
            })
            let data ={
                underwayId: this.userId,
                surveyId: this.id,
                questionScoreResult: JSON.stringify(arr),
                scoreSum: this.sumScoreValue
            }
            console.log(data)
            let params = {
                that: this,
                url: `${this.$config.service.examAddTeacherScore}`,
                method: "POST",
                data: data,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.$message.success('保存成功')
                    }
                },
            };
            this.$util.request(params);
        },
        getData() {
            this.loading = true
            let that = this
            let data = qs.stringify({
                "underwayId": this.userId,
                "surveyId": this.id,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examFindTeacherScore}?${data}`,
                method: "POST",
                cb(res) {
                    that.loading = false
                    // console.log(res)
                    if (res.code == '0'){
                        that.page = 1
                        that.sumScoreValue = res.resultBody.sumScoreValue
                        if (res.resultBody.teacherAnswerJson.length > 0) {
                            that.examPaper = res.resultBody.teacherAnswerJson
                            that.examPaper[0] = that.examPaper[0].filter(info => info.questionsTypeId != 501) || []
                            that.examPaperItem = that.examPaper[0]
                            that.examPaperItem = that.getExamPaperItem(that.examPaperItem)
                        }
                    }
                },
            };
            this.$util.request(params);
        },
        goAnchor(aname) {
            let selector = `div[name=${aname}]`;
            var anchor = this.$el.querySelector(selector)
            console.log(anchor)
            if (anchor) {
                anchor.scrollIntoView({ block: "center", behavior: "smooth" });
            }
        },
    }
}
</script>

<style scoped lang="scss">
.content{
    margin:20px 20px 20px 100px;
        min-width: 1200px;
    .box-card{
        padding: 0 5%;
        background-color: #fff;
        // border: 1px solid #EBEEF5;
        .left{
            background-color: #fff;
            height: 100%;
            padding: 0 !important;
            /deep/.el-dropdown{
                display: flex;
                align-items: center;
                width: 100%;
                line-height: 48px;
                font-size: 15px;
                .el-dropdown-link{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                }
            }
            /deep/.el-dropdown::before{
                content: '';
                width: 2px;
                height: 12px;
                background: #409EFF;
                display: inline-block;
                margin-right: 6px;
            }
            .user-list-box{
                height: calc(100vh - 180px);
                overflow: auto;
                .user-list{
                    line-height: 48px;
                    font-size: 15px;
                    text-align: center;
                    cursor: pointer;
                    /deep/.el-icon-user{
                        color: inherit;
                        font-size: 15px;
                        display: inline-block;
                        margin-right: 5px;
                    }
                }
                .user-list:hover,.user-list-active{
                    color: #509BEA;
                    background-color: rgba(242, 242, 242, 1);
                }
            }
        }
        .center{
            box-sizing: border-box;
            .paper-header{
                line-height: 48px;
                font-size: 15px;
            }
            .paper-header::before{
                content: '';
                width: 2px;
                height: 12px;
                background: #409EFF;
                display: inline-block;
                margin-right: 6px;
            }
            .paper-body{
                height: calc(100vh - 180px);
                overflow: hidden;
                // margin: 30px 0;
                overflow-y: scroll;
            }
            
        }
        
        .right{
            padding: 0 !important;
            .right-header{
                height: 48px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                background-color: #fff;
                .num{
                    font-size: 30px;
                    color: #f76c56;
                }
            }
            .answerSheet{
                width: 100%;
                height: calc(100vh - 180px);
                // margin-top: 20px;
                // position: fixed;
                // top: 200px;
                .header{    
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    /deep/.el-card__header{
                        padding: 9px 20px;
                    }
                    .title{
                        font-size: 15px;
                    }
                    .title::before{
                        content: '';
                        width: 2px;
                        height: 12px;
                        background: #409EFF;
                        display: inline-block;
                        margin-right: 6px;
                    }
                    .sign{
                        font-size: 12px;
                        display: flex;
                    }
                    .sign1{
                        margin-right: 20px;
                        // color: #4abf6f;
                        display: flex;
                        align-items: center;
                    }
                    .sign1::before {
                        content: '';
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        border: 1px solid #4abf6f;
                        background: #e5f8f0;
                        margin-right: 5px;
                        margin-top: 3px;
                    }
                    .sign2{
                        // color: #f76c56;
                        display: flex;
                        align-items: center;
                    }
                    .sign2::before {
                        content: '';
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        border: 1px solid #f76c56;
                        background: #fef0ee;
                        margin-right: 5px;
                        margin-top: 3px;
                    }
                }
                
                .body{
                    padding: 12px 20px;
                    display: flex;
                    flex-wrap: wrap;
                    height: calc(100vh - 369px);
                    overflow: auto;
                    align-content: flex-start;
                    .item_list{
                        margin: 4px 2px;
                        font-size: 12px;
                        line-height: 27px;
                        text-align: center;
                        width: 27px;
                        height: 27px;
                        border-radius: 50%;
                        border: 1px solid #ccc;
                        cursor: pointer;
                    }
                    .item_list1{
                        border: 1px solid #4abf6f;
                        background: #e5f8f0;
                        color: #4abf6f;
                    }
                    .item_list2{
                        border: 1px solid #f76c56;
                        background: #fef0ee;
                        color: #f76c56;
                    }
                }
                .btn-box{
                    text-align: center;
                    padding: 12px 0;
                    border-top: 1px solid #EBEEF5;
                }
                .footer-box{
                    padding: 12px 20px;
                    border-top: 1px solid #EBEEF5;
                    box-sizing: border-box;
                    text-align: center;
                }
            }
        }
    }
}
</style>